import { render, staticRenderFns } from "./FirmaDocumentos.vue?vue&type=template&id=57d0911a"
import script from "./FirmaDocumentos.vue?vue&type=script&lang=js"
export * from "./FirmaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57d0911a')) {
      api.createRecord('57d0911a', component.options)
    } else {
      api.reload('57d0911a', component.options)
    }
    module.hot.accept("./FirmaDocumentos.vue?vue&type=template&id=57d0911a", function () {
      api.rerender('57d0911a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/FirmaDocumentos.vue"
export default component.exports